import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { NotificationLogsTable } from "@/components/notifications/NotificationLogsTable";
import { useNotificationLogs } from "@/hooks/useNotificationLogs";
import { Skeleton } from "@/components/ui/skeleton";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, Mail } from "lucide-react";

const NotificationLogs = () => {
  const { data: logs, isLoading, error } = useNotificationLogs();

  if (error) {
    return (
      <div className="container mx-auto p-6">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            Erro ao carregar logs de notificação: {error.message}
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center gap-3">
        <Mail className="h-8 w-8 text-primary" />
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Logs de Notificações</h1>
          <p className="text-muted-foreground">
            Monitoramento de emails enviados aos clientes
          </p>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Histórico de Notificações</CardTitle>
          <CardDescription>
            Emails enviados nas últimas 24 horas • Atualiza automaticamente a cada hora
          </CardDescription>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="space-y-3">
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} className="h-12 w-full" />
              ))}
            </div>
          ) : (
            <NotificationLogsTable logs={logs || []} />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default NotificationLogs;
